module.exports = __webpack_public_path__ + "static/media/pic6.fcc09e6a.jpg";